var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import PatientCardAPI from './patient-card-api';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './patient-card.css';
let PatientCard = class PatientCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { genero, idade, onClick, nome, nrAtendimento, photo, photoPaciente, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        genero,
                        idade,
                        nome,
                        nrAtendimento,
                        photo,
                        photoPaciente,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
    }; }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-patient-card__indicator' },
            React.createElement("div", { className: 'c-patient-card__indicator-color' })));
    }
    renderContent() {
        const { nome, idade, genero, photo, nrAtendimento: encounterId } = this.props;
        return (React.createElement("div", { className: "c-patient-card__avatar" },
            React.createElement(Avatar, { title: nome, subtitle: `${idade} / ${genero} / ${encounterId}`, image: photo })));
    }
    render() {
        const { nrAtendimento } = this.props;
        return (React.createElement(Card, { width: 12, selectionType: SelectionType.SINGLE, className: 'c-patient-card', uuid: generateUUID(), key: nrAtendimento, onClick: this.handleClick },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-patient-card__wrapper' }, this.renderContent())));
    }
};
PatientCard = __decorate([
    AwesomeComponent({ api: PatientCardAPI, type: ComponentType.DATA_DISPLAY })
], PatientCard);
export default PatientCard;
//# sourceMappingURL=patient-card.js.map